import {useNavigate} from "react-router-dom";
import {Button, Typography} from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import * as React from "react";

export const ShouldPay = () => {
    const navigate = useNavigate()
    return (
        <div className={"page"}>
            <Typography variant={"h1"} align={"center"}>
                <ErrorOutlineIcon sx={{fontSize: 90}}/>
            </Typography>
            <Typography variant={"h4"} align={"center"} gutterBottom>
                Закончился пробный период!
            </Typography>
            <Typography variant={"h5"} align={"center"} gutterBottom>
                Необходимо выбрать тариф подписки!
            </Typography>
            <Button id={"chooseTariff"} variant={"contained"} onClick={() => navigate("/payment")}>Выбрать тариф</Button>
        </div>
    )
}
